import { bumpResourceStat as i } from "./db/resourceStats.js";
import { quoteIdentifier as N } from "./db/identifiers.js";
class R extends Error {
}
const j = /file is in use/i, P = /failed to detach database|database "[^"]*" is not attached/i;
function r(e) {
  return e instanceof Error ? e : new Error(String(e));
}
function W(e) {
  const { db: o, worker: l = null } = e;
  let p = !1, y = null;
  const h = /* @__PURE__ */ new Set(), c = [], d = [];
  async function B() {
    const n = await o.connect();
    return i("connectionsOpened"), h.add(n), n;
  }
  async function m(n) {
    h.has(n) && (h.delete(n), await n.close(), i("connectionsClosed"));
  }
  async function T(n) {
    const s = await B();
    try {
      return await n(s);
    } finally {
      await m(s);
    }
  }
  async function v(n, s) {
    await o.registerFileBuffer(n, s), i("filesRegistered"), c.includes(n) || c.push(n);
  }
  async function k(n) {
    try {
      await o.dropFile(n);
    } catch (a) {
      if (j.test(r(a).message))
        return;
      throw a;
    }
    i("filesDropped");
    const s = c.indexOf(n);
    s > -1 && c.splice(s, 1);
  }
  function I(n, s) {
    d.some(([a]) => a === n) || d.push([n, s]);
  }
  function x(n) {
    const s = d.findIndex(([a]) => a === n);
    s > -1 && d.splice(s, 1);
  }
  async function _() {
    const n = [], s = Array.from(h), a = await Promise.allSettled(
      s.map((t) => m(t))
    );
    for (const t of a)
      t.status === "rejected" && n.push(r(t.reason));
    let w = null;
    try {
      w = await o.connect(), i("connectionsOpened");
      const t = [...d].reverse();
      for (const [C] of t)
        try {
          await w.query(
            `DETACH ${N(C, "database")};`
          );
        } catch (O) {
          const b = r(O);
          P.test(b.message) || n.push(b);
        }
    } catch (t) {
      n.push(r(t));
    } finally {
      if (w)
        try {
          await w.close(), i("connectionsClosed");
        } catch (t) {
          n.push(r(t));
        }
    }
    for (const t of [...c]) {
      try {
        await k(t);
      } catch (C) {
        n.push(r(C));
        continue;
      }
      c.includes(t) && n.push(
        new Error(
          `Could not drop file buffer "${t}": still in use after DETACH.`
        )
      );
    }
    try {
      z();
    } catch (t) {
      n.push(r(t));
    }
    S() === E && A(null);
    try {
      await o.terminate();
    } catch (t) {
      n.push(r(t));
    }
    if (l)
      try {
        await H(l);
      } catch (t) {
        n.push(r(t));
      }
    n.length > 0 && console.warn(
      `DuckDBSession.dispose() encountered ${n.length} failure(s): ${n.map((t) => t.message).join("; ")}`
    );
  }
  function F() {
    return y || (p = !0, y = _()), y;
  }
  const E = {
    db: o,
    get disposed() {
      return p;
    },
    withConnection: T,
    openConnection: B,
    closeConnection: m,
    registerFileBuffer: v,
    dropFileBuffer: k,
    markAttached: I,
    markDetached: x,
    dispose: F
  };
  return E;
}
let D = null;
const g = /* @__PURE__ */ new WeakSet();
function A(e) {
  D = e, q(e ? e.db : null);
}
function $() {
  if (!D)
    throw new R(
      "DuckDB has not been initialized yet. Boot the database before use."
    );
  return D;
}
function S() {
  return D;
}
function G(e) {
  i("workersCreated");
}
async function H(e) {
  g.has(e) || (g.add(e), i("workersTerminated"), await e.terminate());
}
async function J() {
  await S()?.dispose();
}
let L = null;
function q(e) {
  L = e;
}
function K(e) {
  A(W({ db: e }));
}
function Q() {
  return $().db;
}
const u = [], V = (e) => {
  u.push(e), i("listenersAdded");
}, X = (e) => {
  const o = u.indexOf(e);
  o > -1 && (u.splice(o, 1), i("listenersRemoved"));
}, f = {};
function Y(e, o, l) {
  f[e] = { url: o, type: l }, u.forEach((p) => p());
}
function Z(e) {
  return f[e];
}
function ee(e) {
  delete f[e], u.forEach((o) => o());
}
function ne() {
  return f;
}
function z() {
  for (const e of Object.keys(f))
    delete f[e];
  u.forEach((e) => e());
}
export {
  R as D,
  J as a,
  $ as b,
  ne as c,
  L as d,
  V as e,
  X as f,
  Z as g,
  G as h,
  W as i,
  A as j,
  z as k,
  Q as l,
  q as m,
  S as p,
  ee as r,
  Y as s,
  H as t,
  K as u
};
